<template>
  <div>
    <v-card class="hvh-card--rounded my-4">
      <div class="hcp-profile-header pl-5">
        <v-card-title class="text-h5 font-weight-bold pb-0">
          <h2 class="font-weight-bold mb-4"><strong>Ada</strong> - Your Personal AI Research Assistant</h2>
        </v-card-title>
        <v-card-text class="pt-0" style="width: 85%">
          <p>This is <strong>Ada</strong>, EVERSANA's chat bot for answering any question about our open claims data. Just type something you want to know in the box below, press "Submit", and Ada will provide you with your answer shortly.</p>
          <p>To see tips on how to use this tool, please see our <strong>usage guide</strong>.</p>
        </v-card-text>
      </div>

      <div class="flex-container">
        <div class="left-toggle">
          <p class="button" v-for="(key, index) in Object.keys(tabs)" :key="index">
            <button :class="{ 'active-tab': key == value }" @click="selectTab($event, key)">{{ tabs[key].name }}</button>
          </p>
        </div>

        <div class="chatbot" ref="chatbot">
          <div class="position-relative" v-for="(element, ind) in dialogueList" :key="ind">
            <!-- TODO: add save button for both kinds -->
            <div v-if="!element.isExecuted" :class="['chatElement', { chatResponse: element.isChatResponse }]">
              {{ element.textData }}
            </div>
            <!-- TODO: add export button for executed -->
            <template v-else>
              <div v-if="element.textData.length > 0" :class="['chatElement', { chatResponse: element.isChatResponse }]">
                <table class="chatElement">
                  <thead>
                    <tr>
                      <th v-for="key in Object.keys(element.textData[0])" :key="key">{{ key.charAt(0).toUpperCase() + key.substr(1).toLowerCase() }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in element.textData" :key="row">
                      <td v-for="key in Object.keys(row)" :key="key">{{ row[key] }}</td>
                    </tr>
                  </tbody>
                </table>
                <v-btn flat class="hvh-btn hvh-btn--primary ml-0 mr-0 button-float" @click="download($event, element.id)">Download</v-btn>
              </div>
              <div v-else :class="['chatElement', { chatResponse: element.isChatResponse }]">No data available</div>
            </template>
           <div v-if="element.isChatResponse && element.id!=0" class="float-right">
              <v-btn v-if="element.isLike!==false" icon light color="grey" @click="updateIsLikeStatus(true,element)">
              <v-icon :class="selectUpColor(element.isLike)">mdi-thumb-up</v-icon>
              </v-btn>
              <v-btn v-if="element.isLike!==true" icon light color="grey" @click="updateIsLikeStatus(false,element)">
              <v-icon :class="selectDownColor(element.isLike)">mdi-thumb-down</v-icon>
              </v-btn>
            </div>
          </div>
          <loader v-if="isFiltering" />
        </div>
        <div class="left-toggle"></div>
      </div>

      <div class="flex-container">
        <div class="left-toggle"></div>
        <div class="chatInput button">
          <input type="text" class="input-textbox" v-model="inputString" placeholder="Type what you want to know here..." v-on:keyup.enter="submit" />
          <button class="active-tab" style="width: 15%; float: right; margin-bottom: 1%" @click="submit">Submit</button>
        </div>
        <div class="left-toggle"></div>
      </div>
    </v-card>
  </div>
</template>


<script>
import axios from '../../axios'
import Loader from '../../components/common/loader/Loader.vue';
import { Debouncer, errorDebug, hashCode, sanitize } from '../../libraries/common';
import { saveAs } from 'file-saver';


export default {
  components: { Loader },
  props: ['cohortId'],
  data() {
    return {
      inputString: '',
      responseData: '',
      isFiltering: false,
      executeSql: true,
      value: 'executeSQL',
      tabs: { 'executeSQL': { name: "Execute Query" }, 'genSQL': { name: "Generate SQL" } },
      filterObject: {},
      debounceFnc: new Debouncer(2000),
      dialogueList: [{ id: 0, textData: "Hi, I'm Ada! How can I help you? ", isChatResponse: true, isExecuted: false,isLike:null }]
    };

  },
  methods: {
    submit() {
      // show loading indicator
      // clear out the model data 
      // this.modelData = null;
      var textInput = this.inputString;
      this.inputString = "";
      this.isFiltering = true;
      this.dialogueList.push({ id: 0, textData: textInput, isChatResponse: false, isExecuted: false,isLike:null })

      if (this.executeSql) {
        axios.post(`/SQLGenerator/Console/Execute?cohortId=${this.cohortId}`, { input: textInput })
          .then(response => {
            var responseDataObj = response.data;
            var responseData = responseDataObj.results;
            var id = responseDataObj.id;
            if (responseData === null || Array.isArray(responseData) && responseData.length === 0) {
              responseData = ("Did not get a response");
              this.dialogueList.push({ textData: responseData, isChatResponse: true, isExecuted: false,isLike:null });
            }
            else
              this.dialogueList.push({ id: id, textData: responseData, isChatResponse: true, isExecuted: true,isLike:null });

            this.isFiltering = false;
          })
          .catch(errorDebug)
          .then(() => this.isFiltering = false);
      }
      else {
        axios.post(`/SQLGenerator/Console?cohortId=${this.cohortId}`, { input: textInput })
          .then(response => {
            this.responseData = response.data.replaceAll('\n', ' ').replaceAll('\r', ' ');
            this.dialogueList.push({ textData: this.responseData, isChatResponse: true, isExecuted: false,isLike:null });
            this.isFiltering = false;

          })
          .catch(errorDebug)
          .then(() => this.isFiltering = false);
      }


    },
    selectTab(event, key) {
      this.executeSql = !this.executeSql;
      this.value = key;
    },
    download(event, id) {
      //this.loading = true;
      axios.get(`/SQLGenerator/Download?id=${id}&cohortId=${this.cohortId}`)
        .then(({ data }) => {
          let parsedData = JSON.parse(data);
          const headers = Object.keys(parsedData[0]);
          const csvContent = [
            headers.join(','),
            ...parsedData.map(item => headers.map(header => JSON.stringify(item[header])).join(','))
          ].join('\n');
          var blob = new Blob([csvContent], { type: 'text/plain;charset=utf-8' });
          saveAs(blob, sanitize(`Results ${this.browserDateTime(new Date()).replaceAll('/', '-').replaceAll(':', '-')}.csv`));
        })
        .catch(errorDebug)
    },

    updateIsLikeStatus(status,item){
      axios.post(`/SQLGenerator/UpdateIsLikeStatus?cohortId=${this.cohortId}&id=${item.id}`,status)
          .then(() => {
             this.$set(item, 'isLike', status)
          })
          .catch(errorDebug);
    },

    selectUpColor(isLike){
      return {
        'checked': isLike !== null ? isLike : false,
        'unchecked': !isLike
      };
   },

     selectDownColor(isLike){
    return {'checked': isLike !== null ? !isLike : false,
        'unchecked': isLike !== null ? isLike : true};
   }
  },
  computed: {
    filterHash() {
      return hashCode(this.inputString || {});
    }
  },
  watch: {
    filterHash() {
      this.debounceFnc.clear().push(() => this.$emit('refresh-data', this.inputString));
    },
    dialogueList() {
      this.$nextTick(function () {
        var divBottom = this.$refs.chatbot.scrollHeight;
        this.$refs.chatbot.scrollTo(0, divBottom);
      })
    }
  },
  mounted() {
    this.isFiltering = true;
    axios.get(`/SQLGenerator/GetSQLHistory?cohortId=${this.cohortId}`)
      .then(({ data }) => {
        data.forEach(obj => {
          if (obj["isUserInput"])
            this.dialogueList.push({ id: obj["id"], textData: obj["stringData"], isChatResponse: false, isExecuted: false, isLike:obj["isLike"] })
          else {
            if (obj["isSqlRequest"])
              this.dialogueList.push({ id: obj["id"], textData: obj["stringData"], isChatResponse: true, isExecuted: false, isLike:obj["isLike"] })
            else
              this.dialogueList.push({ id: obj["id"], textData: JSON.parse(obj["stringData"]), isChatResponse: true, isExecuted: true, isLike:obj["isLike"] })
          }
        });
      })
      .catch(errorDebug)
      .then(() => this.isFiltering = false);
  }

}

</script>
<style lang="scss" scoped>
.checked{
  color: black !important;
}
.unchecked{
   color: white !important;
}
.flex-container {
  display: flex;
}

.button {
  button {
    background-color: rgba(185, 192, 210, 0.14);
    width: 100%;
    color: #8c9093;
    font-weight: bold;
    letter-spacing: 0.3px;
    padding: 5px 5px;
    border-radius: 5px;
    box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
    text-align: center;
    display: inline-block;
    white-space: nowrap;

    &.active-tab {
      background-color: #060a41;
      color: rgb(255, 255, 255);
    }
  }
}
.hcp-profile-header {
  background-color: #f3f5f7;
}

.input-textbox {
  border: 4px outset #f3f5f7;
  width: 100%;
}

/* Form submit button */
button {
  overflow: visible;
  position: relative;
  float: left;
  margin-top: 1%;
  color: #fff;
  background: #090344;
  border-radius: 4px;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.3);
}

.chatbot {
  flex: 6;
  height: 450px;
  margin: 0 auto;
  margin-top: 2%;
  border: 1px solid #ccc;
  overflow-y: scroll;
  border-radius: 4px;
}

.chatInput {
  flex: 6;
}

.chatResponse {
  background-color: #f3f5f7;
}

.chatElement {
  padding: 8px;
  border-collapse: collapse;
}
.chatElement th,
.chatElement td {
  border: 1px solid #000; /* Add border style */
  padding: 8px; /* Adjust padding as needed */
  text-align: left; /* Adjust text alignment */
}

.left-toggle {
  flex: 1;
  justify-content: center;
  padding: 2%;
}

.button-float {
  float: none;
}
.float-right{
  float:right;
  position:absolute;
  right:0;
  bottom: 0;
}
</style>